import type { C1_AxisData } from "../types/C1_ModelTypes";

type AxisPosition = Pick<C1_AxisData, "kind" | "pos" | "floorId">;
type FloorGeometry = { id: string; rooms: { polygonPoints(): {x: number; y: number}[] }[] };

export function axisUsedOnFloor(axis: AxisPosition, floor: FloorGeometry): boolean {
  const coordinate = axis.kind === "v" ? "x" : "y";
  return floor.rooms.some(room => room.polygonPoints().some(point => Math.abs(point[coordinate] - axis.pos) < 0.001));
}

export function axesForFloor<T extends AxisPosition>(axes: readonly T[], floor: FloorGeometry | undefined, individual: boolean): T[] {
  if (!individual) return [...axes];
  if (!floor) return [];
  return axes.filter(axis => axis.floorId ? axis.floorId === floor.id : axisUsedOnFloor(axis, floor));
}

export function floorsForAxis<T extends FloorGeometry>(axis: AxisPosition, floors: readonly T[], individual: boolean): T[] {
  if (!individual) return [...floors];
  return floors.filter(floor => axis.floorId ? axis.floorId === floor.id : axisUsedOnFloor(axis, floor));
}
